import MUserInvitationRadio from './index.vue';

MUserInvitationRadio.install = app => {
  app.component(MUserInvitationRadio.name, MUserInvitationRadio);
};

export default MUserInvitationRadio;
